import Banner from "~/components/banner"
import CurveCircuitBanner from "./banner"
import Figure from "~/components/figure"
import Circuit from "~/components/circuit"
import MarkdownArticle from "../../components/markdownArticle"

import Weights1 from "./figures/weights1"
import Weights2 from "./figures/weights2"
import Weights3 from "./figures/weights3"
import AngleWeights from "./figures/angleWeights"
import Hue from "./figures/hues"

import { readFileSync } from "fs"
import IncomingCircuit from "./figures/incomingCircuit"
import AngleCircuit from "./figures/angleCircuit"
import GroupConv from "./figures/groupConv"
import AngleAttribution from "./figures/angleAttribution"
import AngleFeatureVis from "./figures/angleFeatureVis"
import AngleMonkey from "./figures/angleMonkey"
import Mechanics from "./mechanics"
import RenderCofabComponent from "~/renderCofabComponent"

const article = readFileSync(__dirname + "/article.md", "utf-8")

export default class CurveCircuit extends Component {
  render() {
    return (
      <React.Fragment>
        <Banner
          title="Curve Circuit"
          subtitle="A deep exploration into the mechanics of the curve detector circuit"
          figure={<CurveCircuitBanner />}
        />
        <MarkdownArticle
          src={article}
          figures={{
            incomingCircuit: <IncomingCircuit />,
            weight1: <Weights1 />,
            weight2: <Weights2 />,
            weight3: <Weights3 />,
            groupConv: <GroupConv />,
            angleCircuit: <AngleCircuit />,
            angleWeights: <AngleWeights />,
            angleAttribution: <AngleAttribution />,
            angleFeatureVis: <AngleFeatureVis />,
            angleMonkey: <AngleMonkey />,
            decomposedVis: (
              <RenderCofabComponent
                folder="circuits-curves"
                component={Mechanics}
              />
            ),
            // hue: <Hue curveLayer="mixed3b" />,
            hue: (
              <Hue
                // neurons={[379, 406, 385, 343, 342, 388, 340, 330, 349, 324]}
                neuronLayer="mixed4a"
                curveLayer="mixed3a"
              />
            ),
          }}
        />
      </React.Fragment>
    )
  }
}

/*
return (
  <React.Fragment>
    <Hue />
    {true && (
      <Hue
        neurons={[379, 406, 385, 343, 342, 388, 340, 330, 349, 324]}
        neuronLayer="mixed3b"
      />
    )}
  </React.Fragment>
)
*/
